import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';
import useConfig from '../hooks/useConfig';

// load locales files
const loadLocaleData = async (locale) => {
  try {
    switch (locale) {
      case 'th':
        return import('../utils/locales/th.json');
      case 'vi':
        return import('../utils/locales/vi.json');
      case 'zh':
        return import('../utils/locales/zh.json');
      case 'en':
        return import('../utils/locales/en.json');
      default:
        return import('../utils/locales/vi.json'); // Default to Vietnamese
    }
  } catch (error) {
    console.error(`Error loading locale data for ${locale}:`, error);
    return import('../utils/locales/vi.json'); // Fallback to Vietnamese
  }
};

const Locales = ({ children }) => {
  const { i18n } = useConfig();
  const [messages, setMessages] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadMessages = async () => {
      setLoading(true);
      try {
        const data = await loadLocaleData(i18n);
        setMessages(data.default);
      } catch (error) {
        console.error('Failed to load messages:', error);
        // Load fallback language
        const fallbackData = await loadLocaleData('th');
        setMessages(fallbackData.default);
      } finally {
        setLoading(false);
      }
    };

    loadMessages();
  }, [i18n]);

  if (loading || !messages) {
    return null; // Or a loading spinner
  }

  return (
    <IntlProvider
      locale={i18n}
      defaultLocale="th"
      messages={messages}
      onError={(err) => {
        if (err.code === 'MISSING_TRANSLATION') {
          console.warn('Missing translation:', err.message);
          return;
        }
        throw err;
      }}
    >
      {children}
    </IntlProvider>
  );
};

Locales.propTypes = {
  children: PropTypes.node
};

export default Locales;
